<div class="container">
  <div style="padding: 10px">
    <div class="wide">
      <div>Name:</div>
      <div>{{ state.displayName }}</div>
    </div>
    <div class="wide">
      <div>Benutzername:</div>
      <div>{{ state.userName }}</div>
    </div>
    <div class="wide">
      <div>Benutzertyp:</div>
      <div>{{ getUserType() }}</div>
    </div>
    <div class="wide">
      <div>Firma:</div>
      <div>{{ (state.selectedCompany$ | async)?.name }}</div>
    </div>
    <div class="wide" *ngIf="state.userHasMinType(1)">
      <div>Cloudspeicher belegt:</div>
      <div>{{ nodeItemsStorageInGb }} GB</div>
    </div>
    <div class="wide">
      <div>App-Version:</div>
      <div (click)="tools.openAppStore()">Version {{ state.version }}</div>
    </div>
    @if(state.updateAvailable){
    <div class="wide">
      <div></div>
      <ion-button (click)="tools.openAppStore()"
        >App-Version aktualisieren</ion-button
      >
    </div>

    }
    <br />
    

    <h5>Unterschrift:</h5>
    @if(this.state.currentSignature != null){
    <lib-signature
      (saveSignature)="saveSignature($event)"
      [currentSignature]="this.state.currentSignature"
    ></lib-signature>
    }
    <ion-button (click)="showHelpModal()" fill="outline">
      <ion-icon name="help-circle-outline" slot="start"></ion-icon>Hilfe
      anzeigen</ion-button
    >
    @if(state.userHasMinType(2)){
       <h5>Firma:</h5>
       <!--ion-button (click)="editCompany()">
      <ion-icon name="help-circle-outline" slot="start" class="white"></ion-icon>Firma bearbeiten
      </ion-button
    -->
    @if(state.userHasMinType(3)){
      <ion-button (click)="createCompany()">
      <ion-icon name="add-outline" slot="start" class="white"></ion-icon>Neue Firma erstellen
      </ion-button
    >
    <br>
    <br>
       <lib-company-picker
      [items]="state.companies$"
      [preselectedItem]="state.selectedCompany$ | async"
      [showAllEntry]="false"
      (selectedItemChanged)="itemChanged($event)"
    ></lib-company-picker>
    }}
  </div>
</div>
